import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id as IdSchema } from '@sigma/common/schema/Id.js';
export const ChatGetEndpointParams = z.object({
    /** ID of the chat to fetch metadata for. */
    chatId: IdSchema,
});
export const ChatGetEndpoint = defineEndpoint({
    name: 'ChatGet',
    input: ChatGetEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=ChatGetEndpoint.js.map